import {
  getLocaleDateFormat,
  getLocaleDateTimeFormat,
  getLocaleDateTimeFormatWithSeconds,
} from 'utils/helpers/locale-date-utils';

// const userLocale = getUserLocale();
export const DATE_FORMAT = getLocaleDateFormat() || 'MM/DD/YYYY';
export const DATE_TIME_FORMAT =
  getLocaleDateTimeFormat() || `${DATE_FORMAT} HH:mm`; // Customize the date time format here if needed
export const DATE_TIME_FORMAT_SECONDS =
  getLocaleDateTimeFormatWithSeconds() || `${DATE_FORMAT} HH:mm:ss`; // Customize the date time with seconds format here if needed

export const TIME_FORMAT = 'HH:mm';

export const YEAR_MONTH_DAY_TIME_FORMAT = 'YYYY-MM-DD HH:mm A';
